export function getOperationName(document) {
  if (!document || !Array.isArray(document.definitions)) {
    return undefined;
  }

  const operationDefinition = document.definitions.find((definition) => {
    return definition && definition.kind === "OperationDefinition";
  });

  if (!operationDefinition || !operationDefinition.name) {
    return undefined;
  }

  return operationDefinition.name.value;
}
